module.exports = __webpack_public_path__ + "img/activity_default_img.02d3a839.jpg";